import consentCheck from '@capsule/consent-check'
import Observer from '@capsule/observer'
import Bvt from '@prismamedia/bvt'
import InitBookmark from 'front/shared/assets/scripts/initBookmark'
import { setBatchEvents, setBatchEventsArticle } from 'front/shared/assets/scripts/setBatchEvents'

class ArticlePage {
	articleContainer: HTMLElement | null
	videoContainer: HTMLElement | null
	videoEmbedContainer: NodeListOf<HTMLElement> | []
	brandTrigram: string | null
	initBookmark: InitBookmark

	constructor() {
		this.articleContainer = document.querySelector('.article')
		this.videoContainer = this.articleContainer?.querySelector('.articleMedia-video') ?? null
		this.videoEmbedContainer =
			this.articleContainer?.querySelectorAll('.video-wrapper-dm-embed') ?? []
		this.brandTrigram = document.body.getAttribute('data-brand-trigram')
		this.initBookmark = new InitBookmark()
	}

	init() {
		this.addEvents()
	}

	addEvents() {
		const firstEmbed = this.articleContainer?.querySelector('[data-site]')
		firstEmbed &&
			consentCheck('allConsentGiven', () => this.onFirstEmbedIntersection(firstEmbed))

		if (this.videoContainer || this.videoEmbedContainer.length) {
			consentCheck('allConsentGiven', () => this.initVideos())
		}

		setBatchEvents(setBatchEventsArticle)
	}

	/**
	 * On first embed intersection actions
	 */
	onFirstEmbedIntersection(firstEmbed: Element): void {
		const observer = new Observer({
			elements: firstEmbed,
			onIntersection: this.initEmbedScripts
		})

		observer.observe()
	}

	/**
	 * Init embed scripts
	 * @returns {void}
	 */
	initEmbedScripts(): void {
		const dataEmbed = document.getElementById('template-embedScript')

		if (dataEmbed instanceof HTMLTemplateElement) {
			const embedScript = dataEmbed.content.cloneNode(true)
			document.body.appendChild(embedScript)
			dataEmbed.remove()
		}
	}

	initVideos() {
		if (this.brandTrigram) {
			const bvt = new Bvt({
				leaderVolume: 0.01
			})
			if (this.brandTrigram === 'voi') {
				setTimeout(() => {
					bvt.init()
				}, 3000)
			} else {
				bvt.init()
			}
		} else {
			console.error('No brand trigram found')
		}
	}
}

export default ArticlePage
